import { BaseBoxShapeTool } from "@tldraw/editor";
class FrameShapeTool extends BaseBoxShapeTool {
  static id = "frame";
  static initial = "idle";
  shapeType = "frame";
  onCreate(shape) {
    if (!shape) return;
    this.editor.reparentShapes(getEnclosedShapeIds(this.editor, shape), shape.id);
    if (this.editor.getInstanceState().isToolLocked) {
      this.editor.setCurrentTool("frame");
    } else {
      this.editor.setCurrentTool("select.idle");
    }
  }
}
function getEnclosedShapeIds(editor, shape) {
  const bounds = editor.getShapePageBounds(shape);
  if (!bounds) return [];
  const enclosedShapeIds = [];
  const ancestorIds = editor.getShapeAncestors(shape).map((shape2) => shape2.id);
  editor.getSortedChildIdsForParent(shape.parentId).map((siblingShapeId) => {
    const siblingShape = editor.getShape(siblingShapeId);
    if (!siblingShape) return;
    if (siblingShape.id === shape.id) return;
    if (siblingShape.isLocked) return;
    const pageShapeBounds = editor.getShapePageBounds(siblingShape);
    if (!pageShapeBounds) return;
    if (bounds.contains(pageShapeBounds)) {
      if (canEnclose(siblingShape, ancestorIds, shape)) {
        enclosedShapeIds.push(siblingShape.id);
      }
    }
  });
  return enclosedShapeIds;
}
function canEnclose(shape, ancestorIds, frame) {
  if (ancestorIds.includes(shape.id)) {
    return false;
  }
  if (shape.parentId === frame.parentId) {
    return true;
  }
  return false;
}
export {
  FrameShapeTool,
  getEnclosedShapeIds
};
//# sourceMappingURL=FrameShapeTool.mjs.map
